module.exports = __webpack_public_path__ + "img/pattern-home.472f8d2e.svg";